export default __webpack_public_path__ + "static/simple-area-32700c07d462b2c88fcd7932f7e4406b.png";